// Pages that moved when the sidebar was regrouped (Team → External Integrations / System Config).
// Used by routes/LegacyRedirect (old URLs redirect to the new ones) and by the tags-view store
// (saved tabs are rewritten on load). More specific prefixes must come first.
export const LEGACY_PATHS: [from: string, to: string][] = [
  ['/team/provider-activity', '/external-integrations/provider-activities'],
  ['/team/provider-request', '/external-integrations/provider-requests'],
  ['/team/provider', '/external-integrations/providers'],
  ['/team/server-configuration', '/system-config/maintenance-message'],
  ['/team/system', '/system-config/system'],
  ['/team/login-history', '/system-config/login-history'],
  ['/mobile/eld-keys', '/system-config/eld-keys'],
  ['/mobile/malfunction', '/system-config/malfunction-letters'],
];

// New path for an old one (keeping any trailing path such as an id), or null if it didn't move
export const resolveLegacyPath = (pathname: string): string | null => {
  const trimmed = pathname.replace(/\/+$/, '');
  for (const [from, to] of LEGACY_PATHS) {
    if (trimmed === from || trimmed.startsWith(`${from}/`)) return to + trimmed.slice(from.length);
  }
  return null;
};
